import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import Link from "next/link";

import useAccess from "hooks/useAccess";
import cls from "lib/common/cls";

import useStyles from "./styles";

export default function NavigationMenuItem({
  className,
  href,
  icon,
  id,
  secondaryAction,
  selected,
  title,
}) {
  const classes = useStyles();
  const { hasFeatureAccess } = useAccess();

  return (
    <Link href={href}>
      <a>
        <ListItem
          button
          className={cls([
            className,
            classes.listItem,
            selected && classes.selected,
          ])}
          id={id}
          secondaryAction={
            !hasFeatureAccess(title) ? (
              <ListItemIcon
                className={cls([classes.listItemIcon, selected && "selected"])}
              >
                <LockOutlinedIcon />
              </ListItemIcon>
            ) : (
              secondaryAction
            )
          }
        >
          {icon && (
            <ListItemIcon
              className={cls([classes.listItemIcon, selected && "selected"])}
            >
              {icon}
            </ListItemIcon>
          )}
          <ListItemText>
            <Typography
              color={(theme) => selected && theme.palette.primary.contrastText}
              variant="body1Semibold"
            >
              {title}
            </Typography>
          </ListItemText>
        </ListItem>
      </a>
    </Link>
  );
}
